export const it = {
  meta: {
    title: 'AuthFlow™ - Autenticazione semplice con email/password e token JWT',
    description: 'Autenticazione affidabile con email/password e token JWT per le applicazioni web moderne. A differenza delle piattaforme complesse, ci concentriamo su ciò che funziona: un accesso sicuro e semplice di cui gli sviluppatori possono fidarsi.',
  },
  // Navigation
  nav: {
    home: 'Home',
    features: 'Caratteristiche',
    pricing: 'Prezzi',
    compare: 'Confronta',
    contact: 'Contatti',
    getStarted: 'Inizia',
    signIn: 'Accedi',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    users: 'Utenti',
    activity: 'Attività',
    settings: 'Impostazioni',
    logout: 'Esci',
    profileSettings: 'Impostazioni profilo',
    activityLog: 'Registro attività',
    welcome: 'Benvenuto nella tua dashboard',
    welcomeBack: 'Bentornato, {name}. Ecco cosa sta succedendo con il tuo servizio di autenticazione.',
    totalUsers: 'Utenti totali',
    activeUsers: 'Utenti attivi',
    totalLogins: 'Accessi totali',
    recentActivity: 'Attività recente',
    noRecentActivity: 'Nessuna attività recente',
    userSettings: 'Impostazioni utente',
    organizationOwnerCannotBeManaged: 'Il proprietario dell\'organizzazione non può essere gestito',
    configureSettings: 'Configura impostazioni',
    hereIsWhatsHappening: 'Ecco cosa sta succedendo con il tuo servizio di autenticazione.',
    fromLastMonth: 'dal mese scorso',
    monthlyLogins: 'Accessi mensili',
    successRate: 'Tasso di successo',
    latestAuthEvents: 'Ultimi eventi di autenticazione e aggiornamenti di sistema',
    viewAllActivity: 'Visualizza tutta l\'attività',
    userManagement: 'Gestione utenti',
    manageApplicationUsers: 'Gestisci gli utenti della tua applicazione',
    viewAllUsers: 'Visualizza tutti gli utenti',
    apiKeys: 'Chiavi API',
    manageApiKeys: 'Gestisci le tue chiavi API di autenticazione',
    systemStatus: 'Stato del sistema',
    authenticationApi: 'API di autenticazione',
    operational: 'Operativo',
    userManagementService: 'Servizio gestione utenti',
    searchUsers: 'Cerca utenti...',
    all: 'Tutti',
    active: 'Attivi',
    inactive: 'Inattivi',
    lastLogin: 'Ultimo accesso',
    never: 'Mai',
    admin: 'Admin',
    owner: 'Proprietario',
    noUsersFound: 'Nessun utente trovato corrispondente ai tuoi criteri',
    noUsers: 'Nessun utente trovato',
    for: 'per',
    noApiKeyFound: 'Nessuna chiave API trovata',
    hideApiKey: 'Nascondi chiave API',
    showApiKey: 'Mostra chiave API',
    created: 'Creato',
    success: 'Successo',
    warning: 'Avviso',
    info: 'Info',
    system: 'Sistema',
    justNow: 'proprio ora',
    minutesAgo: 'minuti fa',
    hoursAgo: 'ore fa',
    daysAgo: 'giorni fa',
    notifications: 'Notifiche',
    billingReminder: 'Promemoria fatturazione',
    noNewNotifications: 'Nessuna nuova notifica',
    logOut: 'Esci',
  },

  // Hero Section
  hero: {
    badge: 'Fidati da 10,000+ sviluppatori',
    title: 'Autenticazione email/password',
    subtitle: 'Fatta bene',
    description: 'Autenticazione semplice, sicura e affidabile con email e password. A differenza delle piattaforme di autenticazione eccessivamente complesse, ci concentriamo su ciò che conta: autenticazione sicura con token JWT che semplicemente funziona.',
    startTrial: 'Inizia prova gratuita',
    getStarted: 'Inizia',
    trialNote: 'Nessuna carta di credito richiesta • 10 Utenti Attivi Mensili gratis',
    metrics: {
      firstIntegrationValue: '5 min',
      firstIntegrationLabel: 'alla prima integrazione',
      predictableSessionsValue: 'JWT',
      predictableSessionsLabel: 'sessioni che restano prevedibili',
      noMazeValue: 'Zero labirinto',
      noMazeLabel: 'per team che vogliono solo un auth che funzioni',
    },
    missionControlLabel: 'Centro controllo auth',
    missionControlTitle: 'Autenticare gli utenti, senza labirinto',
    missionControlStatus: 'Stabile',
    sessionLayer: 'Layer sessione',
    emailPasswordSignIn: 'Accesso email/password',
    roleAwareVerification: 'Verifica con consapevolezza del ruolo',
    validated: 'validato',
    live: 'live',
    integrationShapeLabel: 'Forma integrazione',
    integrationShapeValue: 'API piccola, flusso chiaro',
    forTeamsLabel: 'Per team',
    forTeamsValue: 'Spedire prodotto, non progetti IAM',
  },

  // Features
  features: {
    title: 'Perché AuthFlow™ è diverso',
    description: 'Ci concentriamo sull\'autenticazione email/password con token JWT - la base delle app web sicure. A differenza delle piattaforme che cercano di fare tutto, facciamo una cosa eccezionalmente bene.',
    emailPassword: {
      title: 'Accesso email/password',
      description: 'Autenticazione semplice e sicura con email e password che funziona in modo affidabile. Nessun flusso complesso o funzionalità non necessarie - solo accesso che i tuoi utenti capiscono.',
    },
    jwtTokens: {
      title: 'Gestione token JWT',
      description: 'Gestione corretta dei token JWT per le sessioni, con archiviazione sicura e refresh automatico. Token standard del settore che si integrano perfettamente con la tua API.',
    },
    developerApi: {
      title: 'API per sviluppatori',
      description: 'API RESTful con documentazione completa, SDK e strumenti per sviluppatori. Costruito dagli sviluppatori per il flusso di lavoro DevSecOps.',
    },
  },

  // Testimonials
  testimonials: {
    title: 'Fidati dagli sviluppatori di tutto il mondo',
    testimonial1: {
      text: 'AuthFlow™ ci ha risparmiato mesi di tempo di sviluppo. L\'integrazione è stata seamless e le funzionalità di sicurezza sono di livello enterprise.',
      author: 'Sarah Johnson',
      role: 'CTO, TechStart',
    },
    testimonial2: {
      text: 'Il dashboard analitico ci dà intuizioni incredibili sul comportamento degli utenti. La migliore soluzione di autenticazione che abbiamo usato.',
      author: 'Mike Rodriguez',
      role: 'Sviluppatore principale, AppCorp',
    },
    testimonial3: {
      text: 'Affidabilità rock-solid e supporto eccellente. I nostri utenti amano l\'esperienza di autenticazione fluida.',
      author: 'Alex Liu',
      role: 'Product Manager, InnovateLab',
    },
  },

  // CTA Section
  cta: {
    title: 'Pronto ad aggiungere autenticazione affidabile?',
    description: 'Unisciti agli sviluppatori che scelgono autenticazione semplice ed efficace con email/password e token JWT. Inizia la tua prova gratuita oggi.',
    startTrial: 'Inizia prova gratuita',
  },

  // About Page
  about: {
    title: 'Chi è AuthFlow™ - Esperti di autenticazione semplice email/password',
    description: 'Scopri la missione di AuthFlow™ nel fornire autenticazione affidabile con email/password e token JWT. Fondato nel 2023, rendiamo il login sicuro semplice per ogni sviluppatore.',
    keywords: [
      'autenticazione email password',
      'azienda autenticazione JWT',
      'esperti autenticazione',
      'autenticazione semplice',
      'azienda login sicuro',
      'autenticazione sviluppatore',
      'autenticazione affidabile',
      'autenticazione basata su token',
      'sicurezza app web',
      'piattaforma autenticazione'
    ],
    ogTitle: 'Chi è AuthFlow™ - Esperti di autenticazione semplice email/password',
    ogDescription: 'Scopri la nostra missione nel fornire autenticazione affidabile con email/password e token JWT. A differenza delle piattaforme complesse, ci concentriamo su ciò che funziona.',
    hero: {
      badge: 'Fondato nel 2023',
      title: 'Costruendo il futuro di',
      titleAccent: 'Autenticazione semplice',
      description: 'Siamo in missione per rendere l\'autenticazione email/password con token JWT accessibile a ogni sviluppatore, eliminando la complessità e i rischi di sicurezza della costruzione dell\'autenticazione da zero.',
    },
    mission: {
      title: 'La nostra missione',
      description1: 'Democratizzare l\'autenticazione sicura basata su token che è semplice da implementare e mantenere. Crediamo che ogni applicazione meriti autenticazione semplice e affidabile con email/password e token JWT, senza i mal di testa delle piattaforme over-engineered.',
      description2: 'Diamo priorità alla privacy e alla conformità per design—minimizzando la raccolta dati, crittografando informazioni sensibili a riposo e in transito, e offrendo politiche di retention configurabili. Il nostro obiettivo è aiutare i team a soddisfare i requisiti normativi senza sacrificare usabilità o velocità dello sviluppatore.',
      description3: 'Astrando dalle complessità dei protocolli di sicurezza over-engineered, sicurezza attraverso oscurità e gestione utenti, permettiamo agli sviluppatori di concentrarsi su ciò che fanno meglio: costruire prodotti sorprendenti con autenticazione affidabile.',
    },
    vision: {
      title: 'La nostra visione',
      description1: 'Un mondo dove l\'autenticazione è semplice e affidabile. Immaginiamo un futuro dove ogni applicazione web ha accesso ad autenticazione affidabile con email/password e token JWT, senza la complessità e l\'inaffidabilità delle piattaforme over-engineered.',
      description2: 'Attraverso innovazione continua e sviluppo guidato dalla comunità, stiamo costruendo l\'infrastruttura di autenticazione che si concentra su ciò che conta: login sicuro e semplice su cui gli sviluppatori possono fare affidamento.',
    },
    values: {
      title: 'I nostri valori',
      subtitle: 'I principi che guidano tutto ciò che facciamo in AuthFlow™.',
      reliableSecurity: {
        title: 'Sicurezza affidabile',
        description: 'Ci concentriamo su pratiche di sicurezza battle-tested che funzionano. Autenticazione email/password con corretta gestione token JWT - senza complessità non necessaria.',
      },
      developerFirst: {
        title: 'API per sviluppatori',
        description: 'Siamo ossessionati dal rendere il nostro strumento intuitivo, ben documentato e piacevole da usare. Una grande esperienza sviluppatore porta a prodotti meglio progettati dagli sviluppatori con autenticazione sicura.',
      },
      communityDriven: {
        title: 'Guidato dalla comunità',
        description: 'Il nostro roadmap è formato da te, cliente-sviluppatore. Ascoltiamo, impariamo e costruiamo basandoci su bisogni di sicurezza reali.',
      },
    },
    team: {
      title: 'Incontra il nostro team',
      subtitle: 'Gli individui appassionati che costruiscono il futuro dell\'autenticazione.',
      alex: {
        initials: 'AJ',
        name: 'Alex Johnson',
        role: 'CEO & Co-fondatore',
        bio: 'Ex DevSecOps presso una grande multinazionale finanziaria statunitense. Appassionato di rendere l\'autenticazione affidabile con email/password accessibile a tutti gli sviluppatori.',
      },
      sarah: {
        initials: 'SC',
        name: 'Sarah Chen',
        role: 'CTO & Co-fondatrice',
        bio: 'Architetto full-stack con 10+ anni di costruzione di sistemi di autenticazione affidabili. Esperta in autenticazione email/password e gestione token JWT.',
      },
      marcus: {
        initials: 'MR',
        name: 'Marcus Rodriguez',
        role: 'Head of Product',
        bio: 'Leader di prodotto focalizzato sull\'esperienza sviluppatore e autenticazione affidabile. Esperto in sistemi di login semplici ed efficaci con email/password.',
      },
    },
    stats: {
      title: 'AuthFlow™ in numeri',
      developers: 'Sviluppatori ci fidano',
      authentications: 'Autenticazioni mensili',
      uptime: 'Uptime',
      monitoring: 'Monitoraggio sicurezza',
    },
    cta: {
      title: 'Unisciti alla nostra missione',
      description: 'Pronto a far parte della rivoluzione dell\'autenticazione? Inizia a costruire con autenticazione affidabile email/password oggi.',
      getStarted: 'Inizia gratis',
      contactUs: 'Contattaci',
    },
    breadcrumb: {
      company: 'Azienda',
      aboutUs: 'Chi siamo',
    },
  },

  // Sign In Page
  signIn: {
    title: 'Bentornato',
    subtitle: 'Accedi alla tua autenticazione email/password',
    card: {
      title: 'Accesso organizzazione',
      description: 'Inserisci l\'email del proprietario dell\'organizzazione per accedere al tuo dashboard di autenticazione JWT',
    },
    form: {
      email: {
        label: 'Email',
        placeholder: 'owner@yourorganization.com',
      },
      password: {
        label: 'Password',
        placeholder: 'Inserisci la tua password',
      },
      signIn: 'Accedi',
      signingIn: 'Accesso in corso...',
      noAccount: {
        text: 'Non hai un\'organizzazione?',
        link: 'Creane una',
      },
    },
    errors: {
      emailRequired: 'Email è richiesta',
      failed: 'Accesso fallito',
      unexpected: 'Si è verificato un errore imprevisto. Per favore riprova.',
    },
    success: {
      message: 'Accesso riuscito!',
    },
    agreement: {
      text: 'Accedendo, accetti i nostri',
      terms: 'Termini di servizio',
      and: 'e',
      privacy: 'Informativa sulla privacy',
    },
  },

  // Sign Up
  signUp: {
    title: 'Crea la tua organizzazione',
    subtitle: 'Inizia la tua organizzazione con autenticazione email/password',
    card: {
      title: 'Crea organizzazione',
      description: 'Imposta la tua organizzazione per iniziare con autenticazione email/password e token JWT',
    },
    form: {
      organizationName: {
        label: 'Nome organizzazione',
        placeholder: 'La tua organizzazione',
      },
      organizationWebsite: {
        label: 'Sito web dell\'organizzazione',
        placeholder: 'yourorganization.com',
      },
      emailOwner: {
        label: 'Email proprietario',
        placeholder: 'owner@yourorganization.com',
      },
      password: {
        label: 'Password',
        placeholder: 'Crea una password forte',
      },
      confirmPassword: {
        label: 'Conferma password',
        placeholder: 'Conferma la tua password',
      },
      agreeToTerms: 'Accetto i Termini di servizio e l\'Informativa sulla privacy',
      acceptMarketing: 'Inviami aggiornamenti sui prodotti e email di marketing',
      createOrganization: 'Crea organizzazione',
      creatingOrganization: 'Creazione organizzazione...',
      haveAccount: {
        text: 'Hai già un account?',
        link: 'Accedi',
      },
    },
    errors: {
      organizationNameRequired: 'Nome organizzazione è richiesto',
      organizationWebsiteRequired: 'Il sito web dell\'organizzazione è richiesto',
      emailRequired: 'Email è richiesta',
      passwordRequired: 'Password è richiesta',
      passwordsDoNotMatch: 'Le password non corrispondono',
      agreeToTermsRequired: 'Devi accettare i Termini di servizio e l\'Informativa sulla privacy',
      failed: 'Creazione organizzazione fallita',
      unexpected: 'Si è verificato un errore imprevisto. Per favore riprova.',
    },
    success: {
      message: 'Organizzazione creata con successo!',
    },
    trial: {
      description: 'Inizia a gestire l\'autenticazione della tua organizzazione oggi.',
      features: {
        emailPassword: 'Autenticazione email/password',
        jwtTokens: 'Sicurezza token JWT',
        simpleLogin: 'Login semplice',
      },
    },
  },

  // Pricing Page
  pricing: {
    title: 'Prezzi AuthFlow™ - Costi di autenticazione semplice email/password',
    description: 'Prezzi semplici e trasparenti per autenticazione email/password con token JWT. Inizia gratis e scala man mano che cresci. Nessuna tariffa nascosta, prezzi di autenticazione affidabili.',
    keywords: [
      'prezzi autenticazione',
      'prezzi email password',
      'prezzi JWT',
      'prezzi autenticazione semplice',
      'prezzi autenticazione sviluppatore',
      'costi autenticazione affidabile',
      'prezzi login sicuro',
      'prezzi autenticazione basata su token',
      'prova gratuita autenticazione'
    ],
    ogTitle: 'Prezzi AuthFlow™ - Costi di autenticazione semplice email/password',
    ogDescription: 'Scegli il piano perfetto per le tue esigenze. Inizia gratis e scala man mano che cresci con autenticazione affidabile email/password e token JWT.',
    hero: {
      title: 'Semplici, trasparenti',
      titleAccent: 'prezzi autenticazione',
      description: 'Scegli il piano perfetto per le tue esigenze di autenticazione. Inizia gratis e scala man mano che cresci con autenticazione email/password tramite token di sessione JWT. Nessuna tariffa nascosta, nessuna sorpresa.',
    },
    breadcrumb: {
      product: 'Prodotto',
      pricing: 'Prezzi',
    },
    plans: {
      starter: {
        name: 'Starter',
        description: 'Perfetto per piccoli progetti e test di autenticazione email/password',
        price: '$0',
        period: '/mese',
        features: {
          users: 'Fino a 10 utenti attivi mensili',
          basicAuth: 'Autenticazione base email/password',
          support: 'Supporto standard',
        },
        cta: 'Inizia gratis',
      },
      pro: {
        name: 'Pro',
        description: 'Per aziende in crescita che hanno bisogno di autenticazione affidabile email/password',
        price: '$9.99',
        period: 'primo mese, poi $19.99/mese',
        badge: 'Più popolare',
        features: {
          users: 'Utenti attivi mensili illimitati',
          advancedAuth: 'Autenticazione avanzata email/password',
          support: 'Supporto prioritario',
        },
        cta: 'Inizia prova gratuita',
        monthlyCta: 'Acquista mensile',
        annualCta: 'Acquista annuale',
      },
    },
    faq: {
      title: 'Domande frequenti',
      subtitle: 'Tutto ciò che devi sapere sui nostri prezzi e piani di autenticazione email/password.',
      questions: {
        mau: {
          question: 'Cosa conta come utente attivo mensile?',
          answer: 'Un utente attivo mensile (MAU) è un utente unico che si autentica nella tua applicazione almeno una volta durante un mese di calendario.',
        },
        changePlans: {
          question: 'Posso cambiare piano in qualsiasi momento?',
          answer: 'Sì, puoi aggiornare o declassare il tuo piano in qualsiasi momento. I cambiamenti hanno effetto immediato e la fatturazione è prorata.',
        },
        freeTrial: {
          question: 'C\'è una prova gratuita?',
          answer: 'Sì, tutti i piani a pagamento vengono con una prova gratuita di 3 giorni. Nessuna carta di credito richiesta per iniziare.',
        },
        paymentMethods: {
          question: 'Quali metodi di pagamento accetti?',
          answer: 'Accettiamo tutte le principali carte di credito, Google Pay e Apple Pay.',
        },
      },
    },
    cta: {
      title: 'Pronto a iniziare?',
      description: 'Unisciti a migliaia di sviluppatori che fidano AuthFlow™ per autenticazione affidabile email/password. Inizia la tua prova gratuita oggi.',
      startTrial: 'Inizia prova gratuita',
      contactSales: 'Contatta vendite',
    },
    footer: {
      description: 'Autenticazione semplice e affidabile email/password con token JWT. Fidati dagli sviluppatori di tutto il mondo.',
      product: {
        title: 'Prodotto',
        features: 'Caratteristiche',
        pricing: 'Prezzi',
        apiReference: 'Riferimento API',
      },
      resources: {
        title: 'Risorse',
        gettingStarted: 'Iniziare',
        apiReference: 'Riferimento API',
        support: 'Supporto',
      },
      company: {
        title: 'Azienda',
        about: 'Chi siamo',
        privacy: 'Informativa sulla privacy',
        terms: 'Termini di servizio',
      },
      copyright: '© 2024 AuthFlow™. Tutti i diritti riservati.',
    },
  },

  // Get Started Page
  getStarted: {
    title: 'AuthFlow™ Inizia - Guida alla configurazione di autenticazione email/password | Integrazione API JWT',
    description: 'Guida completa per implementare autenticazione email/password con AuthFlow™. Imposta token JWT per login sicuro in minuti. API developer-friendly per autenticazione affidabile.',
    keywords: [
      'configurazione autenticazione',
      'autenticazione email password',
      'integrazione JWT',
      'guida login sicuro',
      'autenticazione sviluppatore',
      'tutorial API autenticazione',
      'autenticazione basata su token',
      'guida API autenticazione'
    ],
    ogTitle: 'AuthFlow™ Inizia - Guida alla configurazione di autenticazione email/password | Integrazione API JWT',
    ogDescription: 'Guida completa per implementare autenticazione email/password con AuthFlow™. Imposta token JWT per login sicuro in minuti.',
    breadcrumb: {
      resources: 'Risorse',
      getStarted: 'Inizia',
    },
    hero: {
      badge: 'Guida configurazione rapida',
      title: 'Inizia con',
      titleAccent: 'autenticazione email/password',
      description: 'Aggiungi login sicuro email/password alla tua app in minuti, usando autenticazione token JWT fornita dalla nostra piattaforma. Segui la nostra semplice guida di configurazione e sarai presto ad autenticare utenti.',
      createAccount: 'Crea account gratuito',
    },
    steps: {
      title: 'Tre semplici passi per autenticazione sicura email/password',
      subtitle: 'Segui questi passi per integrare gli endpoint di autenticazione AuthFlow™ nelle tue applicazioni backend.',
      step1: {
        number: '1',
        title: 'Crea il tuo account',
        description: 'Iscriviti ad AuthFlow™ e crea il tuo primo progetto. Ricevi istantaneamente la tua chiave API lato server per autenticazione sicura email/password.',
        signUp: 'Iscriviti gratis',
        viewDemo: 'Guarda demo',
      },
      step2: {
        number: '2',
        title: 'Integra endpoint di autenticazione',
        description: 'Usa i nostri endpoint /auth dal tuo backend per gestire autenticazione utenti. Tutti gli endpoint richiedono la chiave API della tua organizzazione per login sicuro email/password.',
        features: {
          apiKeyRequired: 'Chiave API richiesta',
          apiKeyDescription: 'Tutti gli endpoint /auth richiedono la chiave API della tua organizzazione nei token JWT per autenticazione sicura email/password',
          backendIntegration: 'Integrazione backend',
          backendDescription: 'Chiama dal tuo codice lato server, mai esporre chiavi API al frontend',
          sessionManagement: 'Gestione sessioni',
          sessionDescription: 'Gestisci sessioni utenti con token JWT contenenti chiave API org per autenticazione affidabile email/password',
        },
      },
      step3: {
        number: '3',
        title: 'Aggiungi autenticazione',
        description: 'Avvolgi la tua app con il tuo provider e inizia ad usare componenti di autenticazione. È così semplice con autenticazione affidabile email/password!',
        quickStart: 'Avvio rapido',
        fullDocumentation: 'Documentazione completa',
      },
    },
    apiDocs: {
      title: 'Guida tecnica agli endpoint /auth per autenticazione email/password',
      subtitle: 'Documentazione tecnica completa per integrare gli endpoint di autenticazione AuthFlow™ nelle tue applicazioni backend.',
      apiKeySetup: {
        title: 'Configurazione chiave API',
        description: 'La chiave API della tua organizzazione è incorporata in tutti i token JWT per endpoint /auth. Memorizzala in modo sicuro nelle variabili d\'ambiente del tuo backend per autenticazione affidabile email/password.',
        envVars: '# Variabili d\'ambiente',
        apiKeyVar: 'AUTHFLOW_API_KEY=af_your_api_key_here',
        baseUrlVar: 'AUTHFLOW_BASE_URL=https://api.authflow.net',
        securityNote: 'Nota sicurezza: Non esporre mai la tua chiave API nel codice frontend o JavaScript client-side. Tutte le chiamate endpoint /auth devono essere fatte dal tuo server backend per autenticazione sicura email/password.',
      },
      endpoints: {
        foobar: {
          title: 'GET /auth/fooBar',
          description: 'Genera token temporanei anti-abuso per flussi di autenticazione',
          params: 'Parametri:',
          identityParam: 'identity (string): Indirizzo email dell\'utente',
          response: 'Risposta:',
          example: 'Esempio Node.js:',
        },
        signUp: {
          title: 'POST /auth/signUp',
          description: 'Crea nuovi account utente nella tua organizzazione',
          params: 'Parametri:',
          foobarParam: 'foobar (string): Token da /auth/fooBar',
          apiKeyParam: 'api_key (string): Chiave API della tua organizzazione',
          emailParam: 'email (string): Indirizzo email dell\'utente',
          passwordParam: 'password (string): Password dell\'utente (8-32 caratteri, maiuscolo, minuscolo, numero, carattere speciale)',
          fullnameParam: 'fullname (string): Nome completo dell\'utente',
          disclaimedParam: 'disclaimed (string): Deve essere "true"',
          response: 'Risposta:',
          example: 'Esempio Node.js:',
        },
        login: {
          title: 'POST /auth/login',
          description: 'Autentica utenti e ricevi token di sessione',
          params: 'Parametri:',
          foobarParam: 'foobar (string): Token da /auth/fooBar',
          emailParam: 'email (string): Indirizzo email dell\'utente',
          passwordParam: 'password (string): Password dell\'utente',
          apiKeyParam: 'api_key (string): Organization API key',
          response: 'Risposta:',
          tokenNote: 'Il JWT restituito contiene il contesto utente autenticato',
          example: 'Esempio Node.js:',
        },
        validate: {
          title: 'GET /auth/validate',
          description: 'Valida token di sessione utente e controlla stato autenticazione',
          params: 'Parametri:',
          sessionTokenParam: 'sessionToken (string): JWT da /auth/login',
          emailParam: 'email (string): Indirizzo email dell\'utente',
          response: 'Risposta:',
          example: 'Esempio Node.js:',
        },
        changePassword: {
          title: 'POST /auth/changePassword',
          description: 'Permetti agli utenti autenticati di cambiare le loro password',
          params: 'Parametri:',
          sessionTokenParam: 'sessionToken (string): JWT da /auth/login',
          emailParam: 'email (string): Indirizzo email dell\'utente',
          newPasswordParam: 'newPassword (string): Nuova password (stessi requisiti di complessità)',
          response: 'Risposta:',
          example: 'Esempio Node.js:',
        },
        logout: {
          title: 'GET /auth/logout',
          description: 'Termina sessioni utente in modo sicuro',
          params: 'Parametri:',
          sessionTokenParam: 'sessionToken (string): JWT da /auth/login',
          emailParam: 'email (string): Indirizzo email dell\'utente',
          response: 'Risposta:',
          example: 'Esempio Node.js:',
        },
      },
      implementation: {
        title: 'Esempio completo di integrazione backend',
        notes: 'Note di implementazione:',
        note1: 'Memorizza token di sessione in modo sicuro (cookie HTTP-only raccomandati)',
        note2: 'Valida sessioni su percorsi protetti prima di elaborare richieste',
        note3: 'Gestisci scadenza token e refresh come necessario',
        note4: 'Registra eventi di autenticazione per monitoraggio sicurezza',
      },
      errorHandling: {
        title: 'Gestione errori e sicurezza',
        statusCodes: 'Codici di stato HTTP comuni:',
        status200: '200: Successo',
        status400: '400: Richiesta errata (parametri mancanti/non validi)',
        status401: '401: Non autorizzato (token non validi, chiave API errata, ecc.)',
        status404: '404: Utente non trovato',
        status409: '409: Organizzazione già esistente (registrazione)',
        status500: '500: Errore server',
        securityPractices: 'Migliori pratiche di sicurezza:',
        practice1: 'Valida sempre token JWT prima di elaborare richieste',
        practice2: 'Usa HTTPS per tutte le chiamate API',
        practice3: 'Implementa limitazione di velocità sugli endpoint di autenticazione',
        practice4: 'Memorizza token di sessione in cookie HTTP-only, sicuri',
        practice5: 'Registra tutti i tentativi di autenticazione per monitoraggio sicurezza',
        practice6: 'Non registrare mai dati sensibili come password o chiavi API',
        criticalNote: 'Critico: Tutti gli endpoint /auth devono essere chiamati solo dal tuo server backend. Non esporre mai la tua chiave API o fare queste chiamate da JavaScript client-side, poiché ciò comprometterebbe la sicurezza della tua organizzazione.',
      },
    },
    features: {
      title: 'Cosa ottieni out-of-the-box con autenticazione email/password',
      subtitle: 'Collega gli endpoint, noi ti forniamo le Sessioni con token JWT affidabili. È così semplice! 🤝',
    },
    cta: {
      title: 'Pronto ad aggiungere autenticazione affidabile email/password?',
      description: 'Inizia la tua prova gratuita oggi, avrai autenticazione JWT funzionante entro fine giornata.',
      createAccount: 'Crea account gratuito',
      talkToSales: 'Parla con vendite',
    },
    parameters: 'Parametri',
    response: 'Risposta',
    example: 'Esempio',
    runFailureScenario: 'Esegui come scenario di errore',
    failureScenarioOn: 'Scenario di errore: Attivo',
    running: 'In esecuzione...',
    runCurlConsole: 'Esegui cURL in Console',
    copied: 'Copiato!',
    copyCurl: 'Copia curl',
    copyBackendExample: 'Copia codice backend',
    required: 'obbligatorio',
    optional: 'opzionale',
    consoleRunning: 'La console è in esecuzione...',
    consoleDemoTitle: 'Demo Console Linux',
    consoleShellLabel: 'bash -- Console AuthFlow™',
    notesTitle: 'Note',
    endpointContent: {
      session: {
        fooBar: {
          summary: 'Genera un token anti-abuso a breve durata prima di registrazione o login.',
          params: {
            identity: 'Indirizzo email dell\'utente auth.',
            apiKey: 'Chiave API dell\'organizzazione dal pannello proprietario AuthFlow™.',
            role: 'Ruolo RBAC da codificare nel token temporaneo. Predefinito: user.',
          },
          notes: {
            expires: 'Questo token scade in 45 secondi.',
            freshToken: 'Recupera un nuovo token anti-abuso fooBar immediatamente prima di registrazione o login.',
          },
        },
        signUp: {
          summary: 'Crea un nuovo utente di autenticazione nell\'organizzazione proprietaria.',
          params: {
            foobar: 'Token anti-abuso temporaneo restituito da /auth/fooBar.',
            email: 'Indirizzo email dell\'utente.',
            password: 'Password conforme a {passwordRule}.',
            fullname: 'Nome completo dell\'utente auth.',
            role: 'Ruolo RBAC dell\'utente nella tua applicazione.',
            apiKey: 'Chiave API dell\'organizzazione.',
            disclaimed: 'Valore booleano memorizzato nel record utente. La collection usa true.',
          },
          notes: {
            successToken: 'Una registrazione riuscita restituisce subito un token di sessione.',
            duplicateRole: 'Se nella tua organizzazione esistono già la stessa email e ruolo, l\'API restituisce un payload 409.',
          },
        },
        login: {
          summary: 'Autentica un utente e restituisce un token di sessione o una challenge 2FA.',
          params: {
            foobar: 'Token anti-abuso temporaneo restituito da /auth/fooBar.',
            email: 'Indirizzo email dell\'utente.',
            password: 'Password dell\'utente.',
            apiKey: 'Chiave API dell\'organizzazione.',
            role: 'Ruolo utente per login RBAC.',
          },
          notes: {
            tempTokenInsteadOfToken: 'Quando la 2FA è abilitata, login restituisce tempToken invece di token.',
            exchangeThrough2fa: 'Il tempToken viene poi scambiato tramite uno degli endpoint di verifica /auth/2fa.',
          },
        },
        validate: {
          summary: 'Valida un token di sessione per un utente auth.',
          params: {
            sessionToken: 'Token di sessione JWT RS512.',
            email: 'Indirizzo email dell\'utente.',
          },
        },
        me: {
          summary: 'Restituisce il profilo auth-user corrente per una sessione valida.',
          params: {
            sessionToken: 'Token di sessione JWT RS512.',
          },
        },
        logout: {
          summary: 'Disconnette l\'utente auth corrente.',
          params: {
            sessionToken: 'Token di sessione JWT RS512.',
            email: 'Indirizzo email dell\'utente.',
          },
        },
      },
      passwordManagement: {
        forgotPassword: {
          summary: 'Richiede un\'email di reset password per un utente auth (risposta sicura contro enumeration).',
          params: {
            email: 'Indirizzo email dell\'utente auth.',
            apiKey: 'Chiave API dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth. Predefinito: user.',
          },
        },
        resetPassword: {
          summary: 'Reimposta la password di un utente auth con un token di reset valido.',
          params: {
            token: 'Token di reset password dal link email.',
            newPassword: 'Nuova password conforme a {passwordRule}.',
          },
        },
        changePassword: {
          summary: 'Cambia la password dell\'utente auth autenticato.',
          params: {
            sessionToken: 'Token di sessione JWT RS512 corrente.',
            email: 'Email codificata nel token di sessione.',
            oldPassword: 'Password corrente per conferma.',
            newPassword: 'Password sostitutiva conforme a {passwordRule}.',
          },
        },
      },
      emailVerification: {
        verifyEmail: {
          summary: 'Verifica l\'email di un utente auth usando il token inviato via email da AuthFlow™.',
          params: {
            token: 'Token di verifica dal link di verifica email.',
          },
          notes: {
            openedFromEmail: 'Questo endpoint viene di solito aperto cliccando il link di verifica nell\'email.',
            frontendHostedProxy: 'AuthFlow™ supporta anche la verifica ospitata sul frontend tramite /verify-email che fa da proxy a questo controllo.',
          },
        },
        resendVerifyEmail: {
          summary: 'Reinvia l\'email di verifica quando l\'account non è ancora verificato.',
          params: {
            foobar: 'Token temporaneo restituito da /auth/fooBar.',
            email: 'Indirizzo email dell\'utente auth.',
            apiKey: 'Chiave API dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth. Predefinito: user.',
          },
        },
      },
      twoFactor: {
        enable: {
          summary: 'Genera un segreto TOTP e un QR code per un utente auth.',
          params: {
            sessionToken: 'Token di sessione corrente.',
            email: 'Email dell\'utente auth.',
            apiKey: 'UUID dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth.',
          },
        },
        verifySetup: {
          summary: 'Verifica il codice TOTP iniziale e abilita la 2FA.',
          params: {
            sessionToken: 'Token di sessione corrente.',
            email: 'Email dell\'utente auth.',
            apiKey: 'UUID dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth.',
            totpCode: 'Codice a sei cifre dall\'app autenticatore.',
            secret: 'Segreto TOTP restituito da /auth/2fa/enable.',
          },
        },
        disable: {
          summary: 'Disabilita la TOTP 2FA per un utente auth.',
          params: {
            sessionToken: 'Token di sessione corrente.',
            email: 'Email dell\'utente auth.',
            apiKey: 'UUID dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth.',
            password: 'Password corrente.',
          },
        },
        verify2fa: {
          summary: 'Scambia un tempToken di login e un codice TOTP con un token di sessione.',
          params: {
            tempToken: 'tempToken restituito da /auth/login quando la 2FA è abilitata.',
            email: 'Email dell\'utente auth.',
            apiKey: 'UUID dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth.',
            totpCode: 'Codice autenticatore a sei cifre.',
          },
        },
        backupEmail: {
          summary: 'Invia un OTP email di backup usando un tempToken di login.',
          params: {
            tempToken: 'tempToken restituito da /auth/login.',
            email: 'Email dell\'utente auth.',
            apiKey: 'UUID dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth.',
          },
        },
        verifyEmailOtp: {
          summary: 'Scambia un OTP inviato via email con un token di sessione.',
          params: {
            email: 'Email dell\'utente auth.',
            apiKey: 'UUID dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth.',
            emailOtp: 'Codice a sei cifre ricevuto via email.',
          },
        },
        recoveryCodes: {
          summary: 'Rigenera i codici di recupero per un utente auth.',
          params: {
            sessionToken: 'Token di sessione corrente.',
            email: 'Email dell\'utente auth.',
            apiKey: 'UUID dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth.',
            password: 'Password corrente.',
          },
        },
        verifyRecovery: {
          summary: 'Scambia un codice di recupero con un token di sessione.',
          params: {
            email: 'Email dell\'utente auth.',
            apiKey: 'UUID dell\'organizzazione.',
            role: 'Ruolo dell\'utente auth.',
            recoveryCode: 'Uno degli 8 caratteri dei codici di recupero restituiti in precedenza.',
          },
        },
      },
      environment: {
        baseUrl: 'Origine API pubblica.',
        apiKey: 'Chiave API dal pannello proprietario. Conservata solo lato server.',
        defaultRole: 'Valore ruolo/RBAC assegnato all\'utente auth.',
      },
    },
    console: {
      promptPrefix: 'owner@authflow-demo:~$',
      launching: 'Avvio di AuthFlow™ Linux Console v1.0 ...',
      kernel: 'Kernel: Linux 6.8.0-35-generic x86_64',
      curlVersion: 'curl: 8.5.0, OpenSSL: 3.0.x',
      connected: 'Connesso a api.authflow.net',
      sending: '> Invio {method} {path}',
      waiting: '> In attesa di risposta ...',
      serverHeader: '< server: api.authflow.net',
      processExited: '[processo terminato con codice {code}]',
      status: {
        defaultSuccess: 'HTTP/1.1 200 OK (esempio)',
        signup: {
          success: 'HTTP/1.1 201 Created (esempio)',
          alt409: '# alt: HTTP/1.1 409 Conflict quando email+ruolo esistono già',
        },
        login: {
          success: 'HTTP/1.1 200 OK (esempio)',
          alt2fa: '# alt: restituisce payload requires2FA/tempToken quando la 2FA è abilitata',
        },
        verifyEmail: {
          success: 'HTTP/1.1 200 OK (esempio)',
          alt401: '# alt: HTTP/1.1 401 Unauthorized per token di verifica non valido o scaduto',
        },
        validate: {
          success: 'HTTP/1.1 200 OK (esempio)',
          alt401: '# alt: HTTP/1.1 401 Unauthorized per token di sessione non valido o scaduto',
        },
        forgotPassword: {
          success: 'HTTP/1.1 200 OK (risposta sicura contro enumeration)',
        },
        changePassword: {
          success: 'HTTP/1.1 200 OK (esempio)',
          noJsonBody: '# nessun body JSON in caso di successo',
        },
      },
      failure: {
        signup: {
          status: 'HTTP/1.1 409 Conflict (esempio)',
          extra: '# scenario di errore: email+ruolo duplicati',
        },
        login: {
          status: 'HTTP/1.1 400 Bad Request (esempio)',
          extra: '# scenario di errore: credenziali non valide o ruolo non corrispondente',
        },
        verifyEmail: {
          status: 'HTTP/1.1 401 Unauthorized (esempio)',
          extra: '# scenario di errore: token di verifica scaduto',
        },
        validate: {
          status: 'HTTP/1.1 401 Unauthorized (esempio)',
          extra: '# scenario di errore: token di sessione scaduto',
        },
        me: {
          status: 'HTTP/1.1 401 Unauthorized (esempio)',
          extra: '# scenario di errore: sessionToken mancante o non valido',
        },
        logout: {
          status: 'HTTP/1.1 401 Unauthorized (esempio)',
          extra: '# scenario di errore: sessionToken non valido',
        },
        changePassword: {
          status: 'HTTP/1.1 401 Unauthorized (esempio)',
          extra: '# scenario di errore: oldPassword non valida o sessione scaduta',
        },
        resendVerifyEmail: {
          status: 'HTTP/1.1 401 Unauthorized (esempio)',
          extra: '# scenario di errore: token foobar scaduto o api_key non valida',
        },
        fooBar: {
          status: 'HTTP/1.1 400 Bad Request (esempio)',
          extra: '# scenario di errore: identity o api_key mancanti',
        },
        forgotPassword: {
          status: 'HTTP/1.1 400 Bad Request (esempio)',
          extra: '# scenario di errore: email o api_key mancanti',
        },
        resetPassword: {
          status: 'HTTP/1.1 401 Unauthorized (esempio)',
          extra: '# scenario di errore: reset token scaduto',
        },
        default: {
          status: 'HTTP/1.1 400 Bad Request (esempio)',
          extra: '# scenario di errore',
        },
      },
    },
    pageContent: {
      badge: 'Riferimento prodotto auth',
      title: 'Documentazione API AuthFlow™',
      titleAccent: 'per i proprietari dell\'organizzazione',
      description: 'Questa pagina Get Started documenta la nostra auth API pubblica per gli utenti della tua organizzazione. AuthFlow™ offre 20 route /auth totali: 7 route session per autenticazione e gestione utenti, 3 route passwordManagement per il reset password, 2 route emailVerification per la verifica email e 8 route twoFactor per l\'autenticazione a due fattori. La collezione Insomnia scaricabile qui sotto contiene tutte le definizioni degli endpoint, i parametri e le richieste di esempio conformi ai contratti API esatti.',
      downloadCollection: 'Scarica la collezione Insomnia',
      createAccount: 'Crea account proprietario',
      cloneStarterOnGitHub: 'Clona lo starter Next.js',
      starterInfoLabel: 'Informazioni importanti sulla sicurezza dello starter Next.js',
      starterWarningTitle: 'Solo per prototipi e proof of concept',
      starterWarningPrototype: 'authflow-nextjs-starter è destinato esclusivamente a prototipi e frontend proof of concept. Non è un\'integrazione browser per la produzione.',
      starterWarningSecret: 'Non inserire mai una chiave API AuthFlow nel codice frontend di produzione, in variabili di ambiente visibili dal browser, asset statici o bundle client. Tutto ciò che viene inviato a un browser può essere letto da utenti e malintenzionati.',
      starterWarningProduction: 'In produzione, instrada le richieste di autenticazione tramite un backend server-side affidabile o il proxy ExpressJS di AuthFlow e conserva la chiave API in variabili di ambiente server-side o in un gestore di segreti.',
      apiKeyWarningTitle: 'Non esporre mai la chiave API AuthFlow nel codice browser di produzione.',
      apiKeyWarningBody: 'Le chiavi API devono rimanere su un\'infrastruttura sotto il tuo controllo. Non incorporarle in bundle JavaScript, HTML, variabili di ambiente pubbliche, asset web mobili, log o richieste di rete inviate direttamente dal browser. Usa questo proxy ExpressJS o il tuo backend affinché la chiave rimanga server-side.',
      integrationRulesTitle: 'Regole di integrazione',
      integrationRulesRules: [
        'I proprietari dell\'organizzazione devono chiamare AuthFlow™ solo da codice eseguito lato server. Le applicazioni browser devono conservare i segreti come variabili d\'ambiente lato server per chiamare l\'AuthFlow™ API. Questo perché, a differenza della maggior parte dei servizi di autenticazione, AuthFlow™ è progettato per uso server-to-server e per una conformità generale agli standard NIST.',
        'La chiave API del proprietario dell\'organizzazione (la tua) è richiesta per le route principali di gestione sessione e per le altre route.',
        'Il token fooBar è un token anti-abuso a breve durata e deve essere richiesto immediatamente prima di ogni tentativo di registrazione o login, così da essere sempre fresco e valido.',
        'Se il login restituisce requires2FA (cioè l\'utente ha abilitato la 2FA), l\'utente deve completare uno degli scambi di verifica /auth/2fa documentati per ottenere un token di sessione.',
      ],
      ownerAssetsTitle: 'Risorse del proprietario',
      ownerAssetsText: 'Usa la collezione esatta che il tuo team di implementazione può importare in Insomnia.',
      ownerAssetsCollectionName: 'AuthFlow_Consumers.yaml',
      collectionIncludes: 'La collezione include:',
      collectionItems: [
        '7 route pubbliche /auth session',
        '3 route pubbliche /auth passwordManagement',
        '2 route pubbliche /auth emailVerification',
        '8 route pubbliche /auth/2fa twoFactor',
        'Variabili d\'ambiente per chiave API, ruolo/RBAC, token di sessione, TOTP, token temporaneo e flussi con codici di recupero',
      ],
      checklistTitle: 'Checklist di implementazione',
      checklistSubtitle: 'Questo è il flusso consigliato per il proprietario dell\'organizzazione per collegare la tua organizzazione alla sua autenticazione tramite AuthFlow™.',
      configStep: '1. Configura i segreti lato server',
      implementStep: '2. Implementa l\'autenticazione lato server',
      connectStep: '3. Collega il tuo frontend',
      connectStepSecurityNote: 'Il codice del browser non dovrebbe mai archiviare segreti API di AuthFlow™, come la chiave API del proprietario.',
      implementStepRules: [
        'Recupera /auth/fooBar',
        'Chiama /auth/signUp oppure /auth/login',
        'Conserva i token di sessione in modo sicuro',
        'Usa /auth/validate, /auth/me, /auth/changePassword e /auth/logout dalle route protette',
      ],
      connectStepRules: [
        'Invia i form di login e registrazione',
        'Gestisci i prompt 2FA quando l\'API segnala requires2FA',
        'Archivia le sessioni dell\'app in cookie sicuri',
        'Carica l\'utente corrente tramite le risposte degli endpoint session',
      ],
      sessionEndpointsTitle: 'Endpoint sessione',
      sessionEndpointsSubtitle: 'Queste sette route corrispondono a authProduct.session dall\'endpoint root del backend.',
      passwordMgmtTitle: 'Endpoint gestione password',
      passwordMgmtSubtitle: 'Queste tre route corrispondono a authProduct.passwordManagement dall\'endpoint root del backend.',
      emailVerificationTitle: 'Endpoint verifica email',
      emailVerificationSubtitle: 'Queste due route corrispondono a authProduct.emailVerification dall\'endpoint root del backend.',
      twoFactorTitle: 'Endpoint a due fattori',
      twoFactorSubtitle: 'Queste otto route corrispondono a authProduct.twoFactor dall\'endpoint root del backend.',
      serviceExampleTitle: 'Esempio di servizio',
      securityRequirementsTitle: 'Requisiti di sicurezza',
      securityRequirements: [
        'Mantieni AUTHFLOW_API_KEY lato server e cifrata.',
        'Preferisci cookie sicuri HTTP-only per la sessione della tua applicazione.',
        'Valida le sessioni AuthFlow™ prima di servire dati utente protetti.',
        'Gestisci esplicitamente le risposte 400, 401, 404, 409 e 500 nella tua integrazione.',
      ],
      readyCtaTitle: 'Pronto a collegare l\'autenticazione della tua azienda?',
      readyCtaDescription: 'Inizia dalla collezione scaricabile, implementa un\'integrazione sicura del servizio con segreti conservati in modo sicuro e usa l\'assistente in questa pagina se hai bisogno di guida.',
      proxyTitlePrefix: 'ExpressJS ',
      proxyTitleSuffix: ' Proxy',
      proxyDescriptionPrefix: 'Puoi anche scegliere di fare da proxy al backend di AuthFlow dal tuo backend ExpressJS. Questo è probabilmente il modo più sicuro per integrare ',
      proxyDescriptionSuffix: ' nel tuo stack applicativo.',
      proxyDetailsRoutes: 'Il proxy inoltra tutte le route AuthFlow /auth/* e /auth/2fa/*, mantiene la chiave API della tua organizzazione lato server e riduce il rischio di esposizione dei segreti nel codice browser.',
      proxyDetailsDeploy: 'Il proxy è pronto per Vercel, supporta subito lo sviluppo locale e include esempi pratici per registrazione, login, flussi password e verifica 2FA.',
      proxyButton: 'Vedi su GitHub',
    },
  },

  agent: {
    chatbot: {
      title: 'Assistente AuthFlow™',
      inputPlaceholder: 'Chiedi su integrazione /auth o 2FA...',
      greeting: 'Guido i proprietari di organizzazione attraverso il contratto auth-user esatto di AuthFlow™. Chiedimi setup API key owner, endpoint /auth, flussi 2FA, collezione Insomnia, confini frontend-backend o eliminazione account dalla pagina Settings.',
      downloadIntro: 'Usa questa card per scaricare subito la collezione owner da importare.',
      downloadTitle: 'Scarica collezioni Insomnia',
      downloadButton: 'Scarica',
      noAnswer: 'Non ho ricevuto una risposta utilizzabile dall\'agente. Chiedimi un endpoint specifico, un flusso 2FA o uno step backend.',
      error: 'Errore nel contattare l\'assistente. Puoi comunque chiedere del contratto /auth, dei flussi 2FA o della collezione Insomnia e riprovare.',
      toolNotFound: 'Strumento non trovato',
    },
    tools: {
      verificationRecoveryDescription: 'Endpoint di verifica email e recupero password',
      accountSteps: ['1. Registrati come proprietario su https://www.authflow.net/sign-up', '2. Crea l\'organizzazione nella dashboard owner', '3. Copia la API key organizzazione', '4. Definisci i valori role per gli utenti auth', '5. Scarica la collezione Insomnia auth-user di AuthFlow™', '6. Condividi collezione e contratto backend esatto con il team di integrazione'],
      accountManagement: ['Per eliminare definitivamente un\'organizzazione vai in Settings nella dashboard AuthFlow™.', 'Usa Delete Account e digita DELETE per confermare.'],
      reminder: 'La API key owner deve stare solo nel backend aziendale.',
      environmentNotes: ['Mantieni AUTHFLOW_API_KEY solo lato server.', 'AUTHFLOW_DEFAULT_ROLE è opzionale ma utile.', 'Il frontend deve chiamare il proprio backend, non AuthFlow™ direttamente.'],
      backendGuidance: ['Recupera /auth/fooBar subito prima di /auth/signUp o /auth/login.', 'Usa i nomi parametro esatti del contratto pubblico.', 'Se /auth/login restituisce requires2FA, prosegui con la rotta /auth/2fa corretta.', 'Valida e carica l\'utente da route backend, esponendo solo la sessione applicativa al frontend.'],
      insomniaContains: ['Tutti i 12 endpoint pubblici /auth (inclusi verify-email, resend-verify-email, forgot-password, reset-password, deleteUser)', 'Tutti gli 8 endpoint pubblici /auth/2fa', 'Variabili ambiente per API key, role, fooBar token, tempToken, session token, TOTP, email OTP e codici recovery'],
      troubleshoot: {
        solutions: {
          cors: 'Se il browser chiama AuthFlow™ direttamente, fermati: il browser deve chiamare il tuo backend.',
          '401_unauthorized': 'Controlla api_key, role ed email usate in /auth/fooBar o in fase di creazione utente.',
          token_validation: 'Usa esattamente sessionToken + email su /auth/validate; non confondere tempToken con sessionToken.',
          connection_failed: 'Verifica AUTHFLOW_BASE_URL = https://api.authflow.net e la connettivita del backend.',
          api_key_invalid: 'La owner API key deve essere quella dashboard che inizia con af_.',
          foobar_expired: 'fooBar scade velocemente: richiedilo subito prima di sign-up/login.',
          verification_link: 'Il token email deve essere valido e passato come query a /auth/verify-email.',
          password_reset: 'Chiama prima /auth/forgot-password e poi /auth/reset-password con il token ricevuto via email.',
          two_factor_flow: 'Se login restituisce requires2FA, usa tempToken solo nelle route /auth/2fa.',
          organization_deletion: 'Eliminazione organizzazione: dashboard Settings > Delete Account con DELETE.',
          other: 'Confronta la richiesta con il contratto pubblico: parametri, metodo HTTP e posizione query/body/header.',
        },
        commonIssues: ['Frontend che chiama AuthFlow™ direttamente', 'api_key mancante o role errato in /auth/fooBar o /auth/login', 'Uso errato di oldPassword/newPassword in /auth/changePassword', 'Confusione tra tempToken e sessionToken', 'Token verifica scaduto o non valido', 'Saltare /auth/forgot-password prima di /auth/reset-password', 'Saltare verifica 2FA dopo requires2FA', 'Tentare eliminazione organizzazione fuori da Settings'],
      },
    },
  },

  comparisons: {
    hub: {
      breadcrumbRoot: 'Confronta',
      breadcrumbCurrent: 'Confronti prodotti auth',
      title: 'Confronti prodotti auth',
      description: 'Scopri come AuthFlow™ si confronta con le piattaforme di autenticazione più popolari. Tabelle comparative affiancate per aiutarti a scegliere la soluzione auth giusta per il tuo progetto.',
      card: {
        firebase: {
          title: 'Firebase vs. Auth0 vs. AuthFlow™',
          description: 'Confronta Firebase Authentication di Google, la piattaforma enterprise di Auth0 e l\'approccio developer-first di AuthFlow™. Così capisci subito quale soluzione di autenticazione si adatta meglio al tuo stack.',
        },
        supabase: {
          title: 'Supabase vs. Auth0 vs. AuthFlow™',
          description: 'Confronta l\'auth open source di Supabase, l\'offerta enterprise di Auth0 e il servizio di autenticazione essenziale e focalizzato di AuthFlow™. Ideale se sei già nell\'ecosistema Supabase.',
        },
      },
      bullets: {
        core: 'Funzioni auth fondamentali e sicurezza',
        rbac: '2FA, RBAC e multi-tenancy',
        supabaseModel: 'Open source vs. gestito vs. focalizzato',
        pricing: 'Prezzi e lock-in del fornitore',
        dx: 'Esperienza sviluppatore e complessità di setup',
      },
      viewComparison: 'Vedi confronto',
    },
    labels: {
      fullySupported: 'Completamente supportato',
      partial: 'Parziale / limitato',
      notSupported: 'Non supportato',
      feature: 'Funzionalità',
      summary: 'Riepilogo',
      startFree: 'Inizia gratis con AuthFlow™',
      alsoSee: 'Vedi anche:',
      providers: {
        firebase: 'Firebase Auth',
        supabase: 'Supabase Auth',
        auth0: 'Auth0',
        authflow: 'AuthFlow™',
      },
      categories: {
        core: 'Autenticazione di base',
        security: 'Sicurezza',
        userOrg: 'Gestione utenti e organizzazioni',
        dx: 'Esperienza sviluppatore',
        pricing: 'Prezzi e flessibilità',
      },
    },
    features: {
      emailPassword: 'Autenticazione email e password',
      socialLogin: 'Social login (Google, GitHub, ecc.)',
      magicLinks: 'Magic link / accesso senza password',
      smsPhone: 'Autenticazione SMS / telefono',
      anonymous: 'Autenticazione anonima',
      jwt: 'Gestione token JWT',
      rs512: 'Firma con coppia di chiavi RS512',
      twofa: 'Autenticazione a due fattori (2FA)',
      totp: 'App autenticatore TOTP (Google Auth, Authy)',
      backupCodes: 'Codici di backup 2FA',
      emailOtp: '2FA via OTP email',
      rateLimiting: 'Rate limiting',
      emailVerification: 'Verifica email',
      passwordReset: 'Reset password / password dimenticata',
      passwordComplexity: 'Regole di complessità password',
      userDashboard: 'Dashboard gestione utenti',
      rbac: 'Controllo accessi basato sui ruoli (RBAC)',
      multiTenancy: 'Multi-tenancy / Organizzazioni',
      perOrgApiKeys: 'API key per organizzazione',
      auditLogs: 'Log di audit/attività',
      userBlocking: 'Blocco / sospensione utente',
      simpleRest: 'API REST semplice (senza SDK obbligatorio)',
      officialSdks: 'SDK client ufficiali',
      customEmailTemplates: 'Template email personalizzati',
      webhooks: 'Webhook / callback evento',
      selfHosted: 'Opzione self-hosted',
      openSource: 'Open source',
      apiDocs: 'Documentazione API',
      integratedDb: 'Database integrato (PostgreSQL)',
      authOnly: 'Solo auth (nessun database richiesto)',
      freeTier: 'Piano gratuito disponibile',
      flatRate: 'Prezzo fisso prevedibile',
      payPerMau: 'Modello a consumo per MAU',
      lowLockIn: 'Basso lock-in del fornitore',
      lowSetup: 'Bassa complessità di setup',
      noEcosystemBuyIn: 'Funziona senza vincolo di ecosistema',
    },
    notes: {
      firebase2fa: 'Firebase richiede l\'upgrade a Identity Platform per abilitare pienamente la 2FA.',
      firebaseRest: 'Firebase è orientato agli SDK; con REST puro serve gestire manualmente lo scambio token.',
      firebaseLockIn: 'Firebase è fortemente legato all\'ecosistema Google/Firebase.',
      supabaseRls: 'Supabase usa policy di Row-Level Security (RLS) in Postgres.',
      supabaseDb: 'Supabase Auth è strettamente integrato con il database Postgres di Supabase.',
      supabaseLockIn: 'L\'open source di Supabase riduce il lock-in, ma l\'auth resta legata al suo stack Postgres.',
      supabaseAuthOnly: 'Supabase può essere usato solo per auth, ma è progettato come piattaforma backend completa.',
    },
    firebase: {
      breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
      title: 'Firebase vs. Auth0 vs. AuthFlow™',
      description: 'Confronto affiancato tra Firebase Authentication di Google, Auth0 di Okta e AuthFlow™ per aiutarti a scegliere il layer auth più adatto alla tua applicazione.',
      summary: {
        firebaseTitle: 'Firebase Authentication',
        firebaseBody: 'Ideale per team già integrati nell\'ecosistema Google/Firebase. Ha un buon piano gratuito e integrazione SDK-first, ma comporta lock-in e richiede Identity Platform per funzionalità avanzate come la 2FA.',
        auth0Title: 'Auth0',
        auth0Body: 'Il set di funzionalità più completo dei tre: SAML, OIDC, SSO enterprise e ampia personalizzazione. Ideale per grandi team con requisiti complessi, ma i costi crescono rapidamente con i MAU.',
        authflowTitle: 'AuthFlow™',
        authflowBody: 'La scelta giusta per team che vogliono autenticazione email/password con sicurezza robusta (JWT RS512, 2FA, RBAC) senza legarsi a un grande ecosistema. API REST semplice, prezzi prevedibili e setup snello.',
      },
      alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
    },
    supabase: {
      breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
      title: 'Supabase vs. Auth0 vs. AuthFlow™',
      description: 'Confronto affiancato tra l\'auth open source di Supabase, la piattaforma enterprise di Auth0 e AuthFlow™ per aiutarti a scegliere il layer auth più adatto alla tua applicazione.',
      summary: {
        supabaseTitle: 'Supabase Auth',
        supabaseBody: 'Ottimo per team che vogliono un backend open source e self-hostable. Supabase Auth è ricco di funzionalità, con social login, magic link e integrazione profonda con Postgres. Ideale se usi già Supabase come database.',
        auth0Title: 'Auth0',
        auth0Body: 'Il pacchetto più completo: SAML, OIDC, SSO enterprise e personalizzazione avanzata. Scelta forte per team grandi con esigenze di compliance, ma il costo cresce in modo marcato con gli utenti attivi mensili.',
        authflowTitle: 'AuthFlow™',
        authflowBody: 'La scelta ideale quando serve autenticazione email/password affidabile e focalizzata, con sicurezza robusta (JWT RS512, 2FA, RBAC) e senza lock-in di piattaforma. API REST semplice, prezzo prevedibile e setup minimo.',
      },
      alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
    },
  },

  // Common
  common: {
    loading: 'Caricamento...',
    error: 'Si è verificato un errore',
    success: 'Successo',
    cancel: 'Annulla',
    save: 'Salva',
    delete: 'Elimina',
    edit: 'Modifica',
    view: 'Visualizza',
    back: 'Indietro',
    next: 'Avanti',
    previous: 'Precedente',
    language: 'Lingua',
  },

  // SEO
  seo: {
    title: 'AuthFlow™ - Autenticazione sicura resa semplice',
    description: 'Autenticazione basata su token per applicazioni web. Integrazione facile, sicurezza enterprise e API developer-friendly. Inizia la tua prova gratuita oggi.',
    keywords: ['autenticazione', 'autorizzazione', 'sicurezza', 'API', 'autenticazione basata su token', 'JWT', 'strumenti sviluppatore', 'sicurezza web', 'gestione utenti'],
  },

  // Footer (shared across pages)
  footer: {
    description: 'Autenticazione semplice e affidabile email/password con token JWT. Fidati dagli sviluppatori di tutto il mondo.',
    product: 'Prodotto',
    resources: 'Risorse',
    company: 'Azienda',
    apiReference: 'Riferimento API',
    about: 'Chi siamo',
    support: 'Supporto',
    privacyPolicy: 'Informativa sulla privacy',
    termsOfService: 'Termini di servizio',
    copyright: '© 2024 AuthFlow™. Tutti i diritti riservati.',
  },
}
